import React from 'react';

const TickSvg = (props: any) => (
  <svg
    className="tick"
    viewBox="0 0 24 24"
    height={24}
    width={24}
    fill="none"
    {...props}
  >
    <path d="M3.5,10.5l6,6l11-9.5" />
  </svg>
);

export default TickSvg;
